import apiClient from "../../client/apiClient"
import { appendQueryParams } from "../../utils"

const ADMISSION_ENDPOINT = {
  CREATE_ADMISSION: "/admissions",
  GET_ADMISSIONS: "/admissions",
  GET_ADMISSION_BY_ID: "/admissions",
  UPDATE_ADMISSION: "/admissions",
  DELETE_ADMISSION: "/admissions",
  GET_PARENT_BY_CNIC: "/admissions/parent", 
}

const createAdmission = async (data: any) => {
  const response = await apiClient({
    url: ADMISSION_ENDPOINT.CREATE_ADMISSION,
    method: "POST",
    data,
  })
  console.log("Create Admission Response:", response.data)
  return response.data
}

const updateAdmission = async (id: string, data: any) => {
  const response = await apiClient({
    url: `${ADMISSION_ENDPOINT.UPDATE_ADMISSION}/${id}`,
    method: "PUT",
    data,
  })
  return response.data
}

const deleteAdmission = async (id: string) => {
  const response = await apiClient({
    url: `${ADMISSION_ENDPOINT.DELETE_ADMISSION}/${id}`,
    method: "DELETE",
  })
  return response.data
}

const getAdmissions = async ({
  page = 1,
  limit = 10,
 searchText: search,
  sortBy,
  sortOrder,
  class: appliedClass,
  branchId,
  sessionId,
  system,
  gender,
  status,
  startDate,
  endDate,
}: {
  page?: number
  limit?: number
  searchText?: string
  sortBy?: string
  sortOrder?: string
  class?: string
  branchId?: string
  sessionId?: string
  system?: string
  gender?: string
  status?: string
  startDate?: string
  endDate?: string
}) => {
  const response = await apiClient({
    url: appendQueryParams(ADMISSION_ENDPOINT.GET_ADMISSIONS, {
      page,
      limit,
      searchText: search,
      sortBy,
      sortOrder,
      class: appliedClass,
      branchId,
      sessionId,
      system,
      gender,
      status,
      startDate,
      endDate,
    }),
    method: "GET",
  })
  return response.data
}

const getAdmissionById = async (id: string) => {
  const response = await apiClient({
    url: `${ADMISSION_ENDPOINT.GET_ADMISSION_BY_ID}/${id}`,
    method: "GET",
  })
  return response.data
}

const getParentByCnic = async (cnic: string) => {
  const response = await apiClient({
    url: `${ADMISSION_ENDPOINT.GET_PARENT_BY_CNIC}/${cnic}`,
    method: "GET",
  })
  return response.data
}

export {
  createAdmission,
  getAdmissions,
  getAdmissionById,
  updateAdmission,
  deleteAdmission,
  getParentByCnic,
}